import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 12v.01","key":"svg-0"}],["path",{"d":"M3 21h18","key":"svg-1"}],["path",{"d":"M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5","key":"svg-2"}],["path",{"d":"M14 7h7m-3 -3l3 3l-3 3","key":"svg-3"}]]

const IconDoorExit = createReactComponent('outline', 'door-exit', 'DoorExit', __iconNode);

export default IconDoorExit;